import { sectionNames } from "@saleor/intl";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import {
  MembersListUrlSortField,
  permissionSiteDetailsPath,
  PermissionSiteDetailsUrlQueryParams,
} from "./urls";
import PermissionSiteDetailsComponent from "./views/PermissionSiteDetails";





const PermissionSiteDetails: React.FC<RouteComponentProps>=() =>{
  const qs = parseQs(location.search.substr(1));
  const params: PermissionSiteDetailsUrlQueryParams = asSortParams(
    qs,
    MembersListUrlSortField
  );

  return (
    <PermissionSiteDetailsComponent
      params={params}
    />
  );
};

const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.permissionSite)} />
      <Switch>
      
        <Route
          path={permissionSiteDetailsPath}
          component={PermissionSiteDetails}
        />
      </Switch>
    </>
  );
};

export default Component;
